import React, { useEffect, useState } from "react";
import { Menu, X, FileText } from "lucide-react";
import { nav, BROCHURE_URL } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-neg-green/95 backdrop-blur-md shadow-lg shadow-black/10" : "bg-neg-green"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className={`flex items-center justify-between transition-all duration-500 ${scrolled ? "h-16" : "h-20"}`}>
          <a
            href="#top"
            onClick={(e) => handleNav(e, "#top")}
            className="font-display text-neg-gold text-2xl lg:text-3xl italic tracking-wide whitespace-nowrap"
          >
            North East Grove
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {nav.links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={(e) => handleNav(e, l.href)}
                className="relative text-neg-cream/90 text-[15px] tracking-wide hover:text-neg-gold transition-colors duration-300 after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-neg-gold after:transition-all after:duration-300 hover:after:w-full"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={BROCHURE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-2 border border-neg-gold/70 text-neg-gold px-5 py-2.5 text-sm tracking-widest uppercase hover:bg-neg-gold hover:text-neg-green transition-all duration-300"
            >
              <FileText size={15} /> Brochure
            </a>
            <button
              className="md:hidden text-neg-cream p-2"
              onClick={() => setOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden bg-neg-green-dark transition-all duration-500 ${
          open ? "max-h-96" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4">
          {nav.links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={(e) => handleNav(e, l.href)}
              className="py-3 text-neg-cream/90 border-b border-white/5 hover:text-neg-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={BROCHURE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 justify-center border border-neg-gold/70 text-neg-gold px-5 py-3 text-sm tracking-widest uppercase"
          >
            <FileText size={15} /> Brochure
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
